import { LOGIN, LOGOUT } from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    isAuthenticated: false,
    currentUser: {},
    isAdmin: false
};

export const AuthenticationReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                isAuthenticated: action.data.success,
                currentUser: action.data.data,
                isAdmin: (action.data.data && action.data.data.roleName == "superadmin") ? true : false
            };
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                currentUser: {},
                isAdmin: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/AuthenticationReducer.js